// extracted by mini-css-extract-plugin
module.exports = {"sectionHeaderSpacing":"section-header_sectionHeaderSpacing__SYpHX"};